import { render, staticRenderFns } from "./myInvitation.vue?vue&type=template&id=88df835c&scoped=true&"
import script from "./myInvitation.vue?vue&type=script&lang=js&"
export * from "./myInvitation.vue?vue&type=script&lang=js&"
import style0 from "./myInvitation.vue?vue&type=style&index=0&id=88df835c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88df835c",
  null
  
)

export default component.exports